import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {QuestionType} from '../../constants';
import {Question} from '../../models/underwriter.model';
import {UploaderTypes} from '../question-uploaders/question-upload.component';
import {QuestionQuery} from '../state/question.query';
import {GlobalQuestionService} from '../../services/global-question.service';

@Component({
    selector: 'app-question-or-control',
    templateUrl: './question-or-control.component.html',
    styleUrls: ['./question-or-control.component.scss'],
    standalone: false
})
export class QuestionOrControlComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() readonly = false;
  @Input() childrenQuestions: Question[] = [];
  @Output() parentQuestionAnswer = new EventEmitter();

  UploaderTypes = UploaderTypes;
  QuestionType = QuestionType;
  answered = false;
  constructor(private questionQuery: QuestionQuery, private questionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;
      if (this.question) {
        this.getChildrenQuestion();
      }
    }
  }

  getChildrenQuestion(): void {
    this.questionService.spinner(true);
    this.questionService.getChildrenQuestions(this.question?.cent_aq_question_id)
      .subscribe((items: Question[]) => {
        for (const q of items) {
          if (!this.childrenQuestions.some(c => c.cent_aq_question_id === q.cent_aq_question_id)) {
            this.childrenQuestions.push(Object.assign({}, q));
            if (q.answer != ''){
              this.answered = true;
            }
          }
        }
        this.questionService.spinner(false);
      });
      if (this.answered){
        this.emitEvent();
      }

  }

  activateNextButton(event): void {
    const questionIndex = this.childrenQuestions?.findIndex(question => question.cent_aq_question_id === event.cent_aq_question_id);
    if (questionIndex > -1) {
      this.childrenQuestions[questionIndex] = event;
      this.emitEvent();
    }

  }

  emitEvent(): void {
    const excludeUploadList = this.childrenQuestions.filter(q => q.cent_aq_question_type_id !== QuestionType.upload);
    if (excludeUploadList.some(q => q.answer)) {
      excludeUploadList.forEach(q => {
        if (q.answer === '') {
          q.edit = 0;
        }
      });
      this.parentQuestionAnswer.emit(excludeUploadList);
    }
    else {
      excludeUploadList.forEach(q => {
        if (q.answer === '') {
          q.edit = 1;
        }
      });
      this.parentQuestionAnswer.emit(undefined);
    }
  }

}
